import type { HttpCancelToken } from "@okapi/http";
import { api } from "api";
import { LogParams, PostCartAnalyticsParams, PullList, PushList } from './types';

export const pullList = (country: string, cancelToken?: HttpCancelToken) => {
    return api.get<PullList>(`/aem_bws/v3/pullLists`, {
        listTypes: 'BASKET',
        ...(country && { country })
    }, {
        cancelToken
    });
};

export const pushList = (params: PushList, cancelToken?: HttpCancelToken) => {
    return api.post<void, PushList>(`/aem_bws/v3/pushList`, params, {
        cancelToken
    });
};

export const EVENT_ID_BASKET_LOGIC = 707;

export const log = (params: Partial<LogParams>) => {
    return api.post<void, LogParams>(`/ls/api/v1/log`, {
        type: 'info',
        eventId: EVENT_ID_BASKET_LOGIC,
        description: '',
        data: {},
        ...params
    });
};

export const postCartAnalytics = (
  params: PostCartAnalyticsParams,
  cancelToken?: HttpCancelToken
) => {
  return api.post<void, PostCartAnalyticsParams>(
    `/cart-analytics/v1/product-added-to-cart-event`,
    params,
    {
      cancelToken
    }
  );
};